import { FormGroup } from '@angular/forms';
import { GeneratorSearch } from '@psnb/psnb-api';

// Enum for Refuel/Recover actions
export enum RefuelRecoverAction {
  Recover = 'Recover',
  Refuel = 'Refuel'
}

export interface TelemetryGeneratorViewModel {
  generatorDeployed: boolean;
  generatorMinutesRuntime?: string;
  generatorMinutesRuntimeConverted?: number;
  recoverDeployEnabled?: number;
  RefuelRecoverAction: typeof RefuelRecoverAction;
}

export interface DeployGeneratorViewModel {
  comments: string;
  deployGeneratorButtonDisabled: boolean;
  formGroup: FormGroup;
  fuelTankAssetSearchResult: GeneratorSearch[];
  generatorAssetSearchResult: GeneratorSearch[];
  serialNumberSearchResult: GeneratorSearch[];
}

export interface UserPermission {
  category: string;
  functionality: string;
  permission: string;
}
